export default "__VITE_ASSET__BGmPCOr___"